import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { distinctUntilChanged } from 'rxjs/operators';
import { ReferenceDataLabels } from '../../constants/reference-data-labels';
import { ContextualHelpNotifierService } from './../../services/contextual-help-notifier.service';
import { ReferenceDataService } from './../../services/reference-data.service';

@Component({
  selector: 'boi-contextual-help-displayer',
  templateUrl: './contextual-help-displayer.component.html',
  styleUrls: ['./contextual-help-displayer.component.scss']
})
export class ContextualHelpDisplayerComponent implements OnInit {
  @ViewChild('contextualHelpContent') contextualHelpContent;

  public contextualHelpValue: string;

  public showMoreContent: boolean;

  public referenceDataLabels = ReferenceDataLabels;

  constructor(
    private contextualHelpNotifierService: ContextualHelpNotifierService,
    private referenceDataService: ReferenceDataService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.contextualHelpNotifierService.data.pipe(distinctUntilChanged()).subscribe((data) => {
      this.showLess();
      this.contextualHelpValue = this.referenceDataService.getLocalizedContextualHelp(data);
    });
  }

  public showMore(): void {
    this.showMoreContent = true;
    const windowHeight = window.innerHeight;
    const contextualHelpTopOffset = this.contextualHelpContent.nativeElement.getBoundingClientRect().top;
    this.contextualHelpContent.nativeElement.style.maxHeight = `${Math.round(
      windowHeight - contextualHelpTopOffset - 20
    )}px`;
    this.changeDetectorRef.detectChanges();
  }

  public showLess(): void {
    this.showMoreContent = false;
    if (this.contextualHelpContent) {
      this.contextualHelpContent.nativeElement.style.maxHeight = '';
    }
    this.changeDetectorRef.detectChanges();
  }

  public closeContextualHelp(): void {
    this.contextualHelpNotifierService.contextualHelpChanged('');
  }
}
